import React from 'react'
import { connect } from 'react-redux'
import BilansSummary from '../../components/bilans/BilansSummary'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import {
  formulyBilansDomMaklerskiAktywa,
  formulyBilansDomMaklerskiPasywa,
  formulyBilansInnaAktywa,
  formulyBilansInnaPasywa,
  formulyBilansMalaAktywa,
  formulyBilansMalaPasywa,
  formulyBilansMikroAktywa,
  formulyBilansMikroPasywa,
  formulyBilansOpAktywa,
  formulyBilansOpPasywa,
  formulySkonsolidowanyBilansAktywa,
  formulySkonsolidowanyBilansPasywa,
} from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach, dajStrukture } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import BilansStyle from '../../styles/BilansStyle'
import ImportCSVInfo from '../../components/Zestawienie/ImportCSVInfo'
import InfoPanel from '../../components/InfoPanel'

export class Bilans extends React.Component {
  isValueInThirdColumn = () => {
    return (
      this.props.section.Dane.Aktywa.some(i => i.KwotaB1 !== 0) ||
      this.props.section.Dane.Pasywa.some(i => i.KwotaB1 !== 0)
    )
  }

  state = {
    isThirdColumn: this.isValueInThirdColumn(),
    czyszczenie: false,
  }

  setIsThirdColumn = v => {
    this.setState({ isThirdColumn: v })
  }

  handleAktywaClick = () => {
    document.getElementById('aktywa').scrollIntoView()
  }

  handlePasywaClick = () => {
    document.getElementById('pasywa').scrollIntoView()
  }

  sumValues = (value, changedIndex, name, parts, arrayName) => {
    let partsSum = 0
    parts.forEach(x => {
      partsSum = zaokragl(
        partsSum +
          (x === changedIndex
            ? value
            : this.props.section.Dane[arrayName][x][name]),
      )
    })
    return partsSum
  }

  dajFormuly = arrayName => {
    if (arrayName === 'Aktywa') {
      switch (this.props.struktura) {
        case 'Inna':
          return formulyBilansInnaAktywa
        case 'Mikro':
          return formulyBilansMikroAktywa
        case 'Mala':
          return formulyBilansMalaAktywa
        case 'OP':
          return formulyBilansOpAktywa
        case 'DomMaklerski':
          return formulyBilansDomMaklerskiAktywa
        case 'SkonsolidowanaInna':
          return formulySkonsolidowanyBilansAktywa
        default:
          return null
      }
    } else if (arrayName === 'Pasywa') {
      switch (this.props.struktura) {
        case 'Inna':
          return formulyBilansInnaPasywa
        case 'Mikro':
          return formulyBilansMikroPasywa
        case 'Mala':
          return formulyBilansMalaPasywa
        case 'OP':
          return formulyBilansOpPasywa
        case 'DomMaklerski':
          return formulyBilansDomMaklerskiPasywa
        case 'SkonsolidowanaInna':
          return formulySkonsolidowanyBilansPasywa
        default:
          return null
      }
    }
  }

  aktualizujSumy = (value, index, name, arrayName) => {
    if (this.state.czyszczenie) return
    if (!value) value = 0
    const formuly = this.dajFormuly(arrayName)
    this.props.onSetSectionDataCustomArray(value, index, arrayName, name)
    if (formuly && name !== 'Nazwa')
      formuly.forEach(x => {
        const suma = this.sumValues(
          value,
          index,
          name,
          x.polaSkladowe,
          arrayName,
        )
        this.props.onSetSectionDataCustomArray(
          suma,
          x.poleSumy,
          arrayName,
          name,
        )
      })
    this.aktualizujRoznice(value, index, name, arrayName)
  }

  dajNazwePola = name => {
    switch (name) {
      case 'KwotaA':
        return 'RoznicaA'
      case 'KwotaB':
        return 'RoznicaB'
      case 'KwotaB1':
        return 'RoznicaB1'
      default:
        return ''
    }
  }

  aktualizujRoznice = (value, index, name, arrayName) => {
    let nazwa = this.dajNazwePola(name)

    const formulyAktywa = this.dajFormuly('Aktywa')
    const formulyPasywa = this.dajFormuly('Pasywa')
    let valueAktywa = null,
      indexAktywa = null,
      valuePasywa = null,
      indexPasywa = null
    if (arrayName === 'Aktywa') {
      valueAktywa = value
      indexAktywa = index
    } else if (arrayName === 'Pasywa') {
      valuePasywa = value
      indexPasywa = index
    }
    const sumaAktywa = this.sumValues(
      valueAktywa,
      indexAktywa,
      name,
      formulyAktywa[0].polaSkladowe,
      'Aktywa',
    )
    const sumaPasywa = this.sumValues(
      valuePasywa,
      indexPasywa,
      name,
      formulyPasywa[0].polaSkladowe,
      'Pasywa',
    )
    this.props.onSetSectionData(nazwa, zaokragl(sumaAktywa - sumaPasywa), 0)
  }

  czyszczenie = async () => {
    this.setState({ czyszczenie: true })
    this.props.onSetSectionData('RoznicaA', 0, 0)
    this.props.onSetSectionData('RoznicaB', 0, 0)
    this.props.onSetSectionData('RoznicaB1', 0, 0)
    this.props.onClearTable('Aktywa')
    await this.props.onClearTable('Pasywa')
    await this.setState({ czyszczenie: false })
  }

  render() {
    const {
      Aktywa,
      Pasywa,
      RoznicaA,
      RoznicaB,
      RoznicaB1,
    } = this.props.section.Dane
    const { id, onImportCSV, czyKwotyWTysiacach } = this.props
    return (
      <>
        <InfoPanel rolledContent={ImportCSVInfo} />
        <BilansStyle>
          <ZestawienieName
            name="Bilans"
            onImport={file => onImportCSV(id, this.props.section, file)}
            onClear={this.czyszczenie}
          />
          <ZestawienieHeader
            onAktywaClick={this.handleAktywaClick}
            onPasywaClick={this.handlePasywaClick}
            isThirdColumn={this.state.isThirdColumn}
            onCheck={e => this.setIsThirdColumn(e.target.checked)}
          />
          <div className="container">
            <div id="aktywa">
              <Zestawienie
                onSetSectionDataArray={(value, index, name) =>
                  this.aktualizujSumy(value, index, name, 'Aktywa')
                }
                dane={Aktywa}
                czyKwotyWTysiacach={czyKwotyWTysiacach}
                isThirdColumn={this.state.isThirdColumn}
              />
            </div>
            <div id="pasywa">
              <Zestawienie
                onSetSectionDataArray={(value, index, name) =>
                  this.aktualizujSumy(value, index, name, 'Pasywa')
                }
                dane={Pasywa}
                czyKwotyWTysiacach={czyKwotyWTysiacach}
                isThirdColumn={this.state.isThirdColumn}
              />
            </div>
          </div>

          <BilansSummary
            dane={{
              aktywaRazemA: Aktywa[0].KwotaA,
              aktywaRazemB: Aktywa[0].KwotaB,
              aktywaRazemB1: Aktywa[0].KwotaB1,
              pasywaRazemA: Pasywa[0].KwotaA,
              pasywaRazemB: Pasywa[0].KwotaB,
              pasywaRazemB1: Pasywa[0].KwotaB1,
              roznicaA: RoznicaA,
              roznicaB: RoznicaB,
              roznicaB1: RoznicaB1,
            }}
            isThirdColumn={this.state.isThirdColumn}
            czyKwotyWTysiacach={czyKwotyWTysiacach}
          />
        </BilansStyle>
      </>
    )
  }
}
const mapStateToProps = state => ({
  czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
  struktura: dajStrukture(state.sprawozdanie.header),
  id: state.sprawozdanie.header.Id,
})

const mapDispatchToProps = dispatch => ({
  onSetSectionData: (name, value, index) => {
    dispatch(actions.setSectionData(name, value, index))
  },
  onSetSectionDataCustomArray: (value, index, arrayName, name) => {
    dispatch(actions.setSectionDataCustomArray(value, index, arrayName, name))
  },
  onImportCSV: (id, section, file) => {
    dispatch(actions.importCSV(id, section, file))
  },
  onClearTable: array => dispatch(actions.clearTable(array)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Bilans)
